import React from 'react';
import { useSelector } from 'react-redux';
import HelpTextModal from './HelpTextModal';
import { HelpApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { MenuEvents } from '../SharedEvents';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import Tooltip from 'devextreme-react/tooltip';
function HelpText() {
    const user = useSelector((state) => state.user);
    const helpApi = new HelpApi.HelpApi(applicationInsights);
    const menuEvents = new MenuEvents();

    const [openHelpTextModal, set_openHelpTextModal] = React.useState<boolean>(false);
    const [helpText, set_helpText] = React.useState<string>('');

    React.useEffect(() => {
        const ourRequest = axios.CancelToken.source();
        menuEvents.addMenuListener(loadHelp);
        (async () => {
            loadHelp({ detail: window.location.pathname }, ourRequest.token);
        })();

        return () => {
            ourRequest.cancel();
            menuEvents.removeMenuListener(loadHelp);
        };
    }, []);

    const loadHelp = async (event, cancelToken) => {
        const request: HelpApi.IGetPageHelpText = {
            route: event.detail,
        };

        const data = await helpApi.getPageHelpText(request, cancelToken);
        set_helpText(data);
    };

    const _handleHelpText = () => {
        if (!user.admin) return;

        set_openHelpTextModal(true);
    };
    // eslint-disable-next-line
    const _handleHelpTextModalSubmit = (returnText: any) => {
        set_helpText(returnText);
        set_openHelpTextModal(false);
    };

    const _handleHelpTextModalCancel = () => {
        set_openHelpTextModal(false);
    };

    return (
        <>
            <button
                id='helpTooltipTarget'
                className='clear'
                onClick={_handleHelpText}
            >
                <div className='standard-header'>
                    <span className='helper'>
                        <span className='tooltip-trigger'>
                            <FontAwesomeIcon
                                icon={faQuestionCircle}
                                aria-hidden='true'
                                size='lg'
                            />
                        </span>
                    </span>
                </div>
            </button>

            <div className='help-tooltip-scope'>
                <Tooltip
                    target='#helpTooltipTarget'
                    showEvent='mouseenter'
                    hideEvent='mouseleave'
                    contentRender={() => helpText}
                    position={{ my: 'top center', at: 'bottom center' }}
                    wrapperAttr={{ class: 'section-help-tooltip' }}
                />
            </div>

            <HelpTextModal
                isOpen={openHelpTextModal}
                submitCallback={_handleHelpTextModalSubmit}
                cancelCallback={_handleHelpTextModalCancel}
                inputText={helpText}
            />
        </>
    );
}

export default HelpText;
